interface IMetadataObj {
    [x: string]: any;
}

// Months array for date formatting
const months: Array<string> = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

// Character limit for suggestion api
const suggestionApiQueryMaxlength: number = 70;

// Character limit for job search api
const jobSearchQueryMaxlength: number = 128;

// legacy search string keys
// TODO: remove non legeacy fields
const validParamKeys: IMetadataObj = {
    company: "company",
    job_location: "location",
    location: "location",
    job_level: "level",
    keyword: "keyword",
    company_size: "size",
    industry: "industry",
    perks: "perks",
    category: "category",
    work_location: "work_location",
    radius: "radius",
    posted_date_range: "date-posted"
};

const validFilterKeys: IMetadataObj = {
    company: "company",
    location: "location",
    keyword: "keyword",
    experienceLevel: "level",
    companySize: "size",
    industry: "industry",
    perks: "perks",
    category: "category",
    work_location: "work_location",
    radius: "radius",
    postedDateRange: "date-posted",
    companyLeadership: "company-leadership"
};

const legacyJobLevel: IMetadataObj = {
    "entry level": "entry",
    "mid level": "mid",
    "senior level": "senior",
    "management level": "management",
    internship: "internship"
};

const legacyCompanySize: IMetadataObj = {
    "small size": "1_50",
    "medium size": "51_200,201_500",
    "large size": "501_1000,1001_5000,5001_10000,10000_plus",
};

const states = {
    alabama: "AL",
    alaska: "AK",
    arizona: "AZ",
    arkansas: "AR",
    california: "CA",
    colorado: "CO",
    connecticut: "CT",
    delaware: "DE",
    florida: "FL",
    georgia: "GA",
    hawaii: "HI",
    idaho: "ID",
    illinois: "IL",
    indiana: "IN",
    iowa: "IA",
    kansas: "KS",
    kentucky: "KY",
    louisiana: "LA",
    maine: "ME",
    maryland: "MD",
    massachusetts: "MA",
    michigan: "MI",
    minnesota: "MN",
    mississippi: "MS",
    missouri: "MO",
    montana: "MT",
    nebraska: "NE",
    nevada: "NV",
    "new hampshire": "NH",
    "new jersey": "NJ",
    "new mexico": "NM",
    "new york": "NY",
    "north carolina": "NC",
    "north dakota": "ND",
    ohio: "OH",
    oklahoma: "OK",
    oregon: "OR",
    pennsylvania: "PA",
    "rhode island": "RI",
    "south carolina": "SC",
    "south dakota": "SD",
    tennessee: "TN",
    texas: "TX",
    utah: "UT",
    vermont: "VT",
    virginia: "VA",
    "washington state": "WA",
    "west virginia": "WV",
    wisconsin: "WI",
    wyoming: "WY"
};

export {
    months,
    jobSearchQueryMaxlength,
    legacyCompanySize,
    legacyJobLevel,
    states,
    suggestionApiQueryMaxlength,
    validParamKeys,
    validFilterKeys
};
